import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Message } from "@components/atoms";
import { useUserDetails, useWishlist } from "@sdk/react";
import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { RudderAnalytics } from "../../app/analitics";
import { compareAttributes } from "./utils";
export function AddToWishlist(_ref) {
  var variantId = _ref.variantId,
      selectedProductAttributes = _ref.selectedProductAttributes,
      children = _ref.children,
      _ref$showMessage = _ref.showMessage,
      showMessage = _ref$showMessage === void 0 ? false : _ref$showMessage,
      productId = _ref.productId;

  var _useWishlist = useWishlist(),
      addError = _useWishlist.addError,
      addLoading = _useWishlist.addLoading,
      addWishlistProductVariant = _useWishlist.addWishlistProductVariant,
      removeError = _useWishlist.removeError,
      removeLoading = _useWishlist.removeLoading,
      removeWishlistProductVariant = _useWishlist.removeWishlistProductVariant,
      wishlist = _useWishlist.wishlist;

  var intl = useIntl();

  var _useUserDetails = useUserDetails(),
      user = _useUserDetails.data;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showAddMessage = _React$useState2[0],
      setShowAddMessage = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showRemoveMessage = _React$useState4[0],
      setShowRemoveMessage = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      showNotLoggedMessage = _React$useState6[0],
      setShowNotLoggedMessage = _React$useState6[1];

  var isAddedToWishlist = useCallback(function () {
    return wishlist === null || wishlist === void 0 ? void 0 : wishlist.some(function (_ref2) {
      var variant = _ref2.variant,
          productAttributes = _ref2.productAttributes;

      if (variant.id !== variantId) {
        return false;
      }

      return compareAttributes(productAttributes, selectedProductAttributes);
    });
  }, [selectedProductAttributes, variantId, wishlist]);

  var _React$useState7 = React.useState(isAddedToWishlist()),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      addedToWishlist = _React$useState8[0],
      setAddedToWishlist = _React$useState8[1];

  React.useEffect(function () {
    var added = isAddedToWishlist();

    if (added !== addedToWishlist) {
      setAddedToWishlist(added);
    }
  }, [addedToWishlist, isAddedToWishlist, wishlist]);

  var addOrRemoveFromWishlist =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (user) {
                _context.next = 3;
                break;
              }

              setShowNotLoggedMessage(true);
              return _context.abrupt("return");

            case 3:
              if (!addedToWishlist) {
                _context.next = 11;
                break;
              }

              _context.next = 6;
              return removeWishlistProductVariant({
                productAttributes: selectedProductAttributes,
                variantId: variantId
              });

            case 6:
              setShowAddMessage(false);
              setShowRemoveMessage(true); // @ analytics

              RudderAnalytics.track("Product Removed from Wishlist", {
                product_id: productId,
                variant: variantId
              });
              _context.next = 16;
              break;

            case 11:
              _context.next = 13;
              return addWishlistProductVariant({
                productAttributes: selectedProductAttributes,
                variantId: variantId
              });

            case 13:
              setShowRemoveMessage(false);
              setShowAddMessage(true); // @ analytics

              RudderAnalytics.track("Product Added to Wishlist", {
                product_id: productId,
                variant: variantId
              }); // return Promise.resolve();

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function addOrRemoveFromWishlist() {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleRemoveMessageClose = function handleRemoveMessageClose() {
    setShowRemoveMessage(false);
  };

  var handleAddMessageClose = function handleAddMessageClose() {
    setShowAddMessage(false);
  };

  var handleNotLoggedMessageClose = function handleNotLoggedMessageClose() {
    setShowNotLoggedMessage(false);
  };

  var getRemoveMessage = function getRemoveMessage() {
    return !addError ? intl.formatMessage({
      defaultMessage: "Product removed from wishlist",
      "id": "components.ProductDetails.AddToWishlist.1591322319"
    }) : intl.formatMessage({
      defaultMessage: "Error while removing product from wishlist",
      "id": "components.ProductDetails.AddToWishlist.3705458261"
    });
  };

  var getAddMessage = function getAddMessage() {
    return !removeError ? intl.formatMessage({
      defaultMessage: "Product added to wishlist",
      "id": "components.ProductDetails.AddToWishlist.3387841923"
    }) : intl.formatMessage({
      defaultMessage: "Error while adding product to wishlist",
      "id": "components.ProductDetails.AddToWishlist.1791591917"
    });
  };

  return React.createElement(React.Fragment, null, children({
    added: addedToWishlist,
    loading: addLoading || removeLoading,
    onClick: addOrRemoveFromWishlist
  }), showMessage && showAddMessage && !addLoading && React.createElement(Message, {
    title: getAddMessage(),
    status: addError ? "error" : "success",
    onClick: handleAddMessageClose
  }), showMessage && showRemoveMessage && !removeLoading && React.createElement(Message, {
    title: getRemoveMessage(),
    status: removeError ? "error" : "success",
    onClick: handleRemoveMessageClose
  }), showMessage && showNotLoggedMessage && React.createElement(Message, {
    title: intl.formatMessage(_defineProperty({
      defaultMessage: "Please log in to add the product to your wish list",
      "id": "components.ProductDetails.AddToWishlist.2303656441"
    }, "id", "components.ProductDetails.AddToWishlist.2303656441")),
    status: "error",
    onClick: handleNotLoggedMessageClose
  }));
}